module.exports = __webpack_public_path__ + "static/media/29COICT5.4a727885.jpg";